module.exports = __webpack_public_path__ + "img/linkdin.16978e05.svg";